import { VisuallyHidden as ChakraVisuallyHidden } from '@chakra-ui/react';
import React from 'react';
interface VisuallyHiddenProps {
  isHidden?: boolean;
  children?: React.ReactNode | React.ReactNode[];
}

const VisuallyHidden: React.FC<VisuallyHiddenProps> = ({
  isHidden,
  children,
}) => {
  if (isHidden) {
    return <ChakraVisuallyHidden>{children}</ChakraVisuallyHidden>;
  }

  return <>{children}</>;
};

export default VisuallyHidden;
